import React from 'react'
import './Scss/alert.scss'

export enum AlertType {
    PRIMARY = 'primary',
    INFO = 'info',
    SUCCESS = 'success',
    DANGER = 'danger',
}

interface IProps {
    type: string | AlertType
    text: string
    subtext?: string | string[]
    compact?: boolean
    className?: string
}

const Alert = ({ compact = true, ...props }: IProps) => {
    const classes = `${props.className ?? ''} alert--${props.type} ${props.type} ${
        compact ? 'alert--compact' : ''
    }`
    const subText = Array.isArray(props.subtext) ? props.subtext : [props.subtext]
    return (
        <div className={`alert ${classes}`}>
            <div className={`alert__title`}>{props.text}</div>
            {subText &&
              subText.map((txt, index) => <div key={`${index}-${txt}`}>{txt}</div>)}
        </div>
    )
}

export default Alert